export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/b3dc542ec1b5794376b3d1da54a4e35b.svg";